// extracted by mini-css-extract-plugin
var _1 = "head-PgJra";
var _2 = "row-DBo7h";
var _3 = "table-yVHd0";
export { _1 as "head", _2 as "row", _3 as "table" }
